import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { ChangePersonPasswordUseCaseInterface } from 'domain/usecases';

export class RemoteChangePersonPassword
  implements ChangePersonPasswordUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: ChangePersonPasswordUseCaseInterface.Params,
  ): Promise<ChangePersonPasswordUseCaseInterface.Result> {
    const { id, ...restParams } = params;

    const requestUrl = `${this.url}/change-password/${id}`;

    const httpResponse = await this.httpClient.request({
      url: requestUrl,
      body: restParams,
      method: 'put',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
